import axios from 'axios'

export const InvitationsService = {
    loadInvitations: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/invitations')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    invite: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.post('/invitations/invite', payload)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    accept: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/invitations/' + id + '/accept')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    reject: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/invitations/' + id + '/reject')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    cancel: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/invitations/' + id + '/cancel')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    }
}



// WEBPACK FOOTER //
// ./src/services/invitations-service.js